import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { TrosakDokumentStavka } from './trosak-dokument-stavka';

@Component({
  selector: 'yt-trosak-dokument-stavka-inline-update',
  templateUrl: './trosak-dokument-stavka-inline-update.component.html'
})
export class TrosakDokumentStavkaInlineUpdateComponent extends BaseInlineUpdateComponent<TrosakDokumentStavka> {
  constructor(protected inlineContainerService: InlineContainerService<TrosakDokumentStavka>){
    super(inlineContainerService);
  }
}
